import api from "@/lib/api";

// Interroge le statut d'un job d'import/enrichissement jusqu'à "done"/"error".
// onTick(job) est appelé à chaque sondage. Renvoie le job final (ou null si timeout).
export async function pollJob(jobId, onTick, { interval = 2500, maxTries = 400 } = {}) {
  for (let i = 0; i < maxTries; i++) {
    await new Promise((r) => setTimeout(r, interval));
    let job;
    try {
      ({ data: job } = await api.get(`/companies/import-jobs/${jobId}`));
    } catch {
      continue;
    }
    onTick?.(job);
    if (job.status === "done" || job.status === "error") return job;
  }
  return null;
}
